export let ModuleUtils;

(function (_ModuleUtils) {
  function isPromise(obj) {
    return !!obj && typeof obj.then === "function";
  }

  _ModuleUtils.isPromise = isPromise;

  function isSubscribable(obj) {
    return !!obj && typeof obj.subscribe === "function";
  }

  _ModuleUtils.isSubscribable = isSubscribable;
  const isObservable = _ModuleUtils.isObservable = isSubscribable;
})(ModuleUtils || (ModuleUtils = {}));